import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import getUserAuthorizationStatus from 'src/js/modules/user/selectors/user-authorization-status';
import getAvailableSubscriptionTypes from 'src/js/modules/partner/selectors/available-subscription-types';
import filterAvailableTemplates from '../helpers/filter-available-templates';
import getTemplateBySlug from '../selectors/get-template-by-slug';
import fetchTemplateBySlug from '../thunks/fetch-template-by-slug';

const useTemplateBySlug = (templateSlug, locale) => {
  const dispatch = useDispatch();
  const rawTemplate = useSelector(
    (state) => templateSlug && getTemplateBySlug(state, templateSlug)
  );
  const isUserAuthenticated = useSelector(getUserAuthorizationStatus);
  const availableSubscriptionTypes = useSelector(getAvailableSubscriptionTypes, shallowEqual);
  const [isFetchingSingle, setIsFetchingSingle] = useState(false);
  const [attemptedSingleFetch, setAttemptedSingleFetch] = useState(false);

  const template = useMemo(() => {
    if (!rawTemplate) return null;
    return (
      filterAvailableTemplates([rawTemplate], availableSubscriptionTypes, isUserAuthenticated)[0] ||
      null
    );
  }, [rawTemplate, availableSubscriptionTypes, isUserAuthenticated]);

  useEffect(() => {
    if (!templateSlug || rawTemplate || isFetchingSingle || attemptedSingleFetch) return;

    setIsFetchingSingle(true);
    dispatch(fetchTemplateBySlug({ slug: templateSlug, locale })).finally(() => {
      setIsFetchingSingle(false);
      setAttemptedSingleFetch(true);
    });
  }, [templateSlug, rawTemplate, isFetchingSingle, attemptedSingleFetch, dispatch, locale]);

  return { template, attemptedSingleFetch };
};

export default useTemplateBySlug;
